import React, { Component } from 'react';
import { withFirebase } from './Firebase';
import { Link } from '@reach/router';

const budgetMates = [
  // { user: 'Samantha', email: 'sam@somecompany.net' },
  // { user: 'John', email: 'john@google.com' },
  // { user: 'Nate', email: 'bigspender@wegotfunded.com' },
]



class Account extends Component {
  constructor(props) {
    super(props)
    this.state = {
      editName: false,
      editEmail: false,
      editPassword: false,
      email: null,
      password: '',
      name: '',
      nameError: null,
      emailError: null,
      passwordError: null,
    }
    this.inputRef = React.createRef();
  }

  componentDidMount() {
    if (this.props.email !== this.state.email) {
      this.setState({ email: this.props.email })
    }
  }

  updateEmail = (e) => {
    //auth + database
    const email = this.state.email;
    this.props.firebase.doEmailUpdate(email).then(() => {
      //update database
      this.props.firebase.user(this.props.user).update({email: email})
      console.log('Updated')
      this.setState({ emailError: 'Email Updated'})
    }).catch((emailError) => {
      // Show Error
      this.setState({ emailError })
    })
    e.preventDefault()
    this.setState({ editEmail: !this.state.editEmail })
    setTimeout(() => {
      this.setState({ emailError: null })
    }, 2000)
  }

  changePassword = (e) => {
    //auth only
    const password = this.state.password;
    this.props.firebase.doPasswordUpdate(password).then(() => {
      this.setState({ passwordError: 'Password Updated' })
    }).catch(passwordError => {
      //Show Error
      this.setState({ passwordError })
    })
    e.preventDefault()
    this.setState({ editPassword: !this.state.editPassword })
    setTimeout(() => {
      this.setState({ passwordError: null })
    }, 2000);
  }

  updateName = e => {
    //database only
    const name = this.state.name;
    this.props.firebase.user(this.props.user).update({
      name: name,
    }, (nameError) => {
      if (nameError) {
        this.setState({ nameError })
      } else {
        this.setState({ nameError: 'Name Updated' })
        this.setState({ editName: !this.state.editName })
      }
    })
    e.preventDefault()
    setTimeout(() => {
      this.setState({ nameError: null })
    }, 2000)
  }

  onChange = e => {
    this.setState({ [e.target.name]: e.target.value })
  }
  toggleName = () => {
    this.setState({ editName: !this.state.editName })
  }
  toggleEmail = () => {
    this.setState({ editEmail: !this.state.editEmail })
  }
  togglePassword = () => {
    this.setState({ editPassword: !this.state.editPassword })
  }

  render() {
    const {name, email, password, nameError, passwordError, emailError} = this.state;
    const fakePassword = '•••••••••••'
    return (
      <div id="account">
        <div className="logo">
          <Link to='/'><img className="back-button" src="./img/back.svg" alt="back button" /></Link>
          <h1><img src='./img/logo.svg' alt="logo"></img></h1>
          <div className="spacer"></div>
        </div>
        <div className="container">
          <h3>Account Settings</h3>
          <div className="user-fields">
            <label htmlFor="name">First Name</label>
            {!this.state.editName ? (
              <div>
                <div>
                <span>{(this.state.name) || (this.props.name) || 'User'}</span>
                <span className="error">{nameError}</span>
                </div>
                <button onClick={this.toggleName}>Update Name</button>
              </div>
            ) : (
              <div>
                <div>
                <input id="name" name="name" type="text" onChange={this.onChange} value={name} autoFocus />
                  <span className="error">{nameError && nameError.message}</span>
                </div>
                <button onClick={this.updateName}>Save</button>
              </div>
            )}
          </div>
          <div className="user-fields">
            <label htmlFor="email">Email</label>
            {!this.state.editEmail ? (
              <div>
                <div>
                <span>{this.props.email}</span>
                <span className="error">{emailError}</span>
                </div>
                <button onClick={this.toggleEmail}>Update Email</button>
              </div>
            ) : (
              <div>
                <div>
                  <input id="email" name="email" type="email" onChange={this.onChange} value={email} autoFocus />
                  <span className="error">{emailError && emailError.message}</span>
                </div>
                <button onClick={this.updateEmail}>Save</button>
              </div>
            )}
          </div>
          <div className="user-fields">
            <label htmlFor="password">Password</label>
            {!this.state.editPassword ? (
              <div>
                <div>
                  <span>{fakePassword}</span>
                  <span className="error">{passwordError}</span>
                </div>
                <button onClick={this.togglePassword}>Change Password</button>
              </div>
            ) : (
              <div>
                <div>
                  <input id="password" name="password" type="password" onChange={this.onChange} value={password} autoFocus />
                  <span className="error">{passwordError && passwordError.message}</span>
                </div>
                <button onClick={this.changePassword}>Save</button>
              </div>
            )}
          </div>
          <div className="budgetmates">
            <h3>Budgetmates</h3>
              <ul>
                {(budgetMates.length > 0) ? (
                  budgetMates.map(({index, user, email}) => (
                    <li key={user}>
                      <span className="account-name">{user}</span>
                      <span className="account-email">{email}</span>
                    </li>
                  ))
                ) : (
                  <p>Coming Soon...</p>
                )}
              </ul>
          </div>
          <div className="help">
            <h5>Help & Support</h5>
            <a href="mailto: help@accruabl.com">help@accruabl.com</a>
            <div className="image"><img src="./img/savings.svg" alt="piggy bank" /></div>
          </div>
        </div>
      </div>
    )
  }
}



export default withFirebase(Account);